import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { APIURL,TZ } from "../../Global";
export const Footer = () => {
  const { t } = useTranslation();
  
  const [footerData, setFooterData] = useState(null);
  useEffect(() => {
    axios.get(`${APIURL}/api/v1/account/footer-details/?src=web&${TZ}`)
      .then(response => {
        setFooterData(response.data.footer_data);
      })
      .catch(error => {
        console.error('Error fetching footer data:', error);
      });
  }, []);

  if (!footerData) {
    return null;
  }

  return (
    <footer className="footer">     
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-contact-info">
            <p><span className="contact-label">{t('phone')}:</span>
              <span className="contact-value">{footerData.customer_service || ''}</span></p>
             
            <p><span className="contact-label">{t('email')}:</span>
              <span className="contact-value">{footerData.email || ''}</span></p>

            <p><span className="contact-label">{t('address')}:</span>
              <span className="contact-value">{footerData.address || ''}</span></p>

            {footerData.website && (
              <p>
                <span className="contact-label">{t('website')}:</span>
                <span className="contact-value">
                  <a style={{textDecoration: 'none', color: '#666'}} href={`https://${footerData.website}`} target="_blank" rel="noopener noreferrer">
                    {footerData.website}
                  </a>
                </span>
              </p>
            )}

            {/* <div className="social-icons">
              <a href="#" className="social-icon facebook">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                </svg>
              </a>
              <a href="#" className="social-icon wordpress">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M12.158,12.786L9.46,20.625c0.806,0.237,1.657,0.366,2.54,0.366c1.047,0,2.051-0.181,2.986-0.51 c-0.024-0.038-0.046-0.079-0.065-0.124L12.158,12.786z M3.009,12c0,3.559,2.068,6.634,5.067,8.092L3.788,8.341 C3.289,9.459,3.009,10.696,3.009,12z M18.069,11.546c0-1.112-0.399-1.881-0.741-2.48c-0.456-0.741-0.883-1.368-0.883-2.109 c0-0.826,0.627-1.596,1.51-1.596c0.04,0,0.078,0.005,0.116,0.007C16.472,3.904,14.34,3.009,12,3.009 c-3.141,0-5.904,1.612-7.512,4.052c0.211,0.007,0.41,0.011,0.579,0.011c0.94,0,2.396-0.114,2.396-0.114 C7.947,6.93,8.004,7.642,7.52,7.699c0,0-0.487,0.057-1.029,0.085l3.274,9.739l1.968-5.901l-1.401-3.838 C9.848,7.756,9.389,7.699,9.389,7.699C8.904,7.67,8.961,6.93,9.446,6.958c0,0,1.484,0.114,2.368,0.114 c0.94,0,2.397-0.114,2.397-0.114c0.485-0.028,0.542,0.684,0.057,0.741c0,0-0.488,0.057-1.029,0.085l3.249,9.665l0.897-2.996 C17.841,13.284,18.069,12.316,18.069,11.546z M19.889,7.686c0.039,0.286,0.06,0.593,0.06,0.924c0,0.912-0.171,1.938-0.684,3.22 l-2.746,7.94c2.673-1.558,4.47-4.454,4.47-7.771C20.991,10.436,20.591,8.967,19.889,7.686z M12,22C6.486,22,2,17.514,2,12 C2,6.486,6.486,2,12,2c5.514,0,10,4.486,10,10C22,17.514,17.514,22,12,22z" />
                </svg>
              </a>
              <a href="#" className="social-icon linkedin">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                </svg>
              </a>
            </div> */}
          </div>

          <div className="footer-column">
            <h3>{t('information')}</h3>
            <ul>
              {/* <li><Link to="#">{t('aboutUs')}</Link></li>
              <li><Link to="#">{t('contactUs')}</Link></li> */}
              <li><Link to="#">{t('privacyPolicy')}</Link></li>
              <li><Link to="#">{t('terms')}</Link></li>
              {/* <li><Link to="/delivery">{t('deliveryInfo')}</Link></li> */}
              {/* <li><Link to="/returns">{t('ordersReturns')}</Link></li> */}
            </ul>
          </div>

          {/* <div className="footer-column"> */}
            {/* <h3>{t('customerCare')}</h3>
            <ul>
              <li><Link to="#">{t('help')}</Link></li>
              <li><Link to="#">{t('myAccount')}</Link></li> */}
              {/* <li><Link to="/orders">{t('orderHistory')}</Link></li> */}
              {/* <li><Link to="/wishlist">{t('wishlist')}</Link></li> */}
              {/* <li><Link to="/newsletter">{t('newsletter')}</Link></li> */}
              {/* <li><Link to="#">{t('purchasingPolicy')}</Link></li> */}
            {/* </ul> */}
          {/* </div> */}

          {/* <div className="footer-newsletter">
            <h3>{t('newsletter')}</h3>
            <p>{t('newsletterText')}</p>

            <div className="newsletter-form">
              <input type="email" placeholder={t('enterEmail')} />
              <button>{t('subscribeNow')}</button>
            </div>
          </div> */}
        </div>
      </div>

      <div className="footer-copyright">
      {footerData.copyright ? footerData.copyright.split('All Rights Reserved')[0] : ''}
      {t('all_rights_reserved')}
      </div>
    </footer>
  );
};

export default Footer;